export const base = {
  inherit: "inherit",
  initial: "initial",
  unset: "unset",
}

export type Base = Record<keyof typeof base, string>
